<template>
  <div class="emtpy font-sc-re">
    <div class="empty-img flex">
      <img src="../../../assets/empty.png" alt="" />
    </div>
    <div class="empty-text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: "Emtpy",
  props: {
    // 缺省文案
    text: {
      type: String,
      default: "暂无对应的相关详情哦~"
    }
  }
};
</script>

<style lang="sass" scoped>
@import "~@/styles/mixins/vw"
.emtpy
  width: 100%
  height: 100%
  text-align: center
.empty-img
  width: vw(514)
  height: vw(514)
  margin: vw(138) auto 0
.empty-text
  margin-top: vw(40)
  font-size: vw(28)
  color: #404040
</style>
